import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { IconIdCard } from 'assets/svg/sprite'
import { Button } from 'components/Button/Button'

import { SectionTitle, StepHeader, StepNumber } from '../../../components-ref/templates/verification/VerificationPersonalInformation/VerificationPersonalInformation'


export default function VerificationPending() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    return (
        <Container>
            <StepHeader>
                <StepNumber>SUBMITTED</StepNumber>
                <SectionTitle>Personal Information</SectionTitle>
            </StepHeader>
            <IdCardContainer>
            <IconIdCard />
            </IdCardContainer>
            <Title>
                {t('yourAccount')} <br /> {t('isPendingReview')}
            </Title>
            <CloseButtonWrapper>
                <Button
                    text={t('close')}
                    color='blue'
                    width='100'
                    height='5'
                    font='mont-16-semi-bold'
                    customClass='verification-close-btn'
                    clickFn={() => navigate('/following')}
                />
            </CloseButtonWrapper>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`
const Title = styled.div`
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.02em;
    font-size: 2.2rem;
    line-height: 3.6rem;
    color: #0d1444;
    max-width: 23rem;
    text-align: center;
`
const IdCardContainer = styled.div`
    padding-top: 5rem;   // or whatever top padding you want
    display: flex;
    justify-content: center;
    align-items: center;
`

const CloseButtonWrapper = styled.div`
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: transparent;   // or white, if you want an overlay look
    z-index: 10;
    display: flex;
    justify-content: center;
    padding-bottom: 2.8rem;   // adjust for spacing from bottom edge

    .verification-close-btn {
        border-radius: 100px;
        box-shadow: 0 8px 24px 0 rgba(40, 139, 253, 0.15);
        font-weight: 600;
        font-size: 1.6rem;
        min-width: 200px;
        max-width: 200px;
        width: 90%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`